import { axiosIntance } from 'src/app/core/config/AxiosConfig';

export const InvoiceRepository = {
  makePayment: (form: object) => {
    return axiosIntance.post('/invoice/payment/make', form);
  }
};
